/**
 * Runs a one-shot fullscreen confetti animation.
 * Creates a canvas overlay, animates particles, then removes the canvas.
 */
export default function runConfetti() {
  const duration = 8000;
  const particleCount = 500;
  const colors = ['#27E8E8', '#ff9af5', '#4f00fa', '#E3FCFC', '#ff4286', '#d8c6ff'];

  const canvas = document.createElement('canvas');
  canvas.style.cssText =
    'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  let width = window.innerWidth;
  let height = window.innerHeight;
  canvas.width = width;
  canvas.height = height;

  const resize = () => {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
  };
  window.addEventListener('resize', resize);

  const particles = [];
  for (let i = 0; i < particleCount; i++) {
    particles.push({
      x: Math.random() * width,
      y: -200 + Math.random() * 400,
      vx: (Math.random() - 0.5) * 2,
      vy: 0.15 + Math.random() * 0.5,
      color: colors[Math.floor(Math.random() * colors.length)],
      size: 4 + Math.random() * 10,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 4,
    });
  }

  const start = performance.now();

  function tick() {
    const elapsed = performance.now() - start;
    if (elapsed >= duration) {
      window.removeEventListener('resize', resize);
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      return;
    }

    ctx.clearRect(0, 0, width, height);

    const progress = elapsed / duration;
    const gravity = 0.018;
    const drag = 0.9995;

    for (let i = 0; i < particles.length; i += 1) {
      const p = particles[i];
      p.vy += gravity;
      p.vx *= drag;
      p.vy *= drag;
      p.x += p.vx;
      p.y += p.vy;
      p.rotation += p.rotationSpeed;

      const alpha = progress < 0.6 ? 1 : 1 - (progress - 0.6) / 0.4;
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rotation * Math.PI) / 180);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
      ctx.restore();
    }

    requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}
